/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignVolunteerRequest
 */
export interface AssignVolunteerRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignVolunteerRequest
     */
    volunteerId: string;
}

/**
 * Check if a given object implements the AssignVolunteerRequest interface.
 */
export function instanceOfAssignVolunteerRequest(value: object): value is AssignVolunteerRequest {
    if (!('volunteerId' in value) || value['volunteerId'] === undefined) return false;
    return true;
}

export function AssignVolunteerRequestFromJSON(json: any): AssignVolunteerRequest {
    return AssignVolunteerRequestFromJSONTyped(json, false);
}

export function AssignVolunteerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignVolunteerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'volunteerId': json['volunteerId'],
    };
}

export function AssignVolunteerRequestToJSON(json: any): AssignVolunteerRequest {
    return AssignVolunteerRequestToJSONTyped(json, false);
}

export function AssignVolunteerRequestToJSONTyped(value?: AssignVolunteerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'volunteerId': value['volunteerId'],
    };
}

